<template>
  <div>
    <custom-callout
      :hasBorder="false"
      :has-toggle="
        verifyToggle || recommendedPanelShow || recommendedReasonSuccess
      "
      :opened="recommendedPanelShow"
      :controlled="true"
      class="mb-3 mt-1 bg-callout"
      @click:open="handleCallout()"
    >
      <div class="row mt-2 pl-1 evaluetions-card">
        <div class="col-md-2 col-sm-12" style="padding-bottom: 10px">
          <div class="font-weight-normal font-14 color-gray--6">
            Evaluación Adicional
          </div>

          <span class="font-weight-normal font-16 color-black--2">
            <strong>{{ itemsEval.disciplineTypeName }}</strong>
          </span>
          <hr class="divider-horizontal" />
        </div>

        <div class="vl" />
        <div
          class="col-md-2 col-sm-12 top-reductor"
          style="padding-bottom: 10px"
        >
          <div class="font-weight-normal font-14 color-gray--6">
            Estatus de Evaluación:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            {{ itemsEval.statusName }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12" style="padding-bottom: 10px">
          <div class="font-weight-normal font-14 color-gray--6">
            Fecha de Evaluación:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            {{ itemsEval.evaluationDate }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12" style="padding-bottom: 10px">
          <div class="font-weight-normal font-14 color-gray--6">
            Estatus de la Discusión:
          </div>
          <span class="font-weight-normal font-16 color-black--2">
            {{ itemsEval.discussionStatusDescription }}
          </span>
        </div>
        <div class="col-md-2 col-sm-12">
          <div style="height: 75px" class="row justify-content-end">
            <div class="col-12">
              <span class="font-weight-normal font-14 color-gray--6">
                ¿Recomienda?
              </span>
              <validation-provider v-slot="{ errors }" rules="required">
                <custom-radio
                  v-model="model.recommended"
                  :change-event="
                    (item) => {
                      onChangeYesNo(item);
                    }
                  "
                  class="custom-radio__extended p-0 m-0"
                  container-class="custom-radio-center"
                  custom-error-msg="Marque si o no."
                  :error="Boolean(errors[0])"
                  is-question-list
                  name="question-1"
                  :options="questions[0].radioOptions"
                  :disabled="isSubmitted"
                />
              </validation-provider>
            </div>
          </div>
        </div>
        <div class="col-md-2 col-sm-12" />
        <div v-if="!isMobile && !isSubmitted" class="btn-remove-evluation">
          <ActionButton
            variant="drop-item"
            i="fas fa-times-circle text-red font-25 mt-3 icon-align"
            @click="$emit('on-delete')"
          />
        </div>       
      </div>

      <div class="row ml-1 pt-3 mr-4">
        <div class="col-lg-11 col-md-10 col-sm-11 p-0">
          <div class="font-weight-normal font-16 color-gray--6">
            <span> <i class="fas fa-info-circle text-orange font-25" /></span>
            Requiere reevaluación a partir de la implementación de
            recomendaciones ofrecidas en este informe de evaluación:
            <b class="color-black">
              {{ itemsEval.reevaluationTime }}
              {{ itemsEval.reevaluationPeriod }}
            </b>
          </div>
          <p class="pl-4">
            <b>Comentario: {{ itemsEval.reevaluationPurpose }}</b>
          </p>
        </div>
      </div>

      <template #edition>
        <div class="px-0 py-1">
          <div class="bg-white rounded px-3 py-1 my-2 mx-2">
            <div class="row pt-3 mr-4">
              <div class="pl-3">
                <i class="fas fa-info-circle text-orange" />
              </div>
              <div class="col-md-10 col-sm-10">
                <b>
                  {{
                    model.recommended
                      ? "Información de Evaluación Recomendada"
                      : "Información de Evaluación No Recomendada"
                  }}
                </b>
              </div>
            </div>
            <validation-observer ref="evaluationToRecommendedForm">
              <div class="mt-2 pr-2" :class="!isSubmitted ? 'pb-4' : ''">
                <span>
                  {{
                    model.recommended
                      ? "Razón de Referido para Recomendar:"
                      : "Razón para No Recomendar:"
                  }}
                </span>
                <validation-provider
                  v-if="!isSubmitted"
                  v-slot="{ errors }"
                  rules="required"
                >
                  <CustomTextArea
                    v-show="true"
                    :id="'isRecomendationNeeded'"
                    v-model="model.recomendationComment"
                    placeholder="Escribe un comentario"
                    style="width: 100%"
                    :maxlength="3000"
                    :classes="['eq-field', 'text-right']"
                    :rows="5"
                    :error="errors[0]"
                    custom-error-msg="La razón es requerida."
                    :disabled="isSubmitted"
                    @input="onChangeComment"
                  />
                </validation-provider>
                <p v-if="isSubmitted">
                  {{ model.recomendationComment }}
                </p>
              </div>

              <div class="container-foot d-flex justify-content-end">
                <ActionButton
                  v-if="!isSubmitted"
                  variant="outline-danger m-2"
                  i="fa fa-times-circle"
                  @click="handleCancel"
                >
                  Cancelar
                </ActionButton>                
              </div>
            </validation-observer>
          </div>
        </div>
      </template>
    </custom-callout>
  </div>
</template>

<script>
import CustomCallout from "custom-callout";
import CustomRadio from "custom-radio";
import alertMixin from "@/mixin/alert.mixin";
import CustomTextArea from "@/components/common/CustomTextArea";
import ActionButton from "ActionButton";
import { ValidationProvider, ValidationObserver } from "vee-validate";

export default {
  name: "EvaluationRecommendRow",
  components: {
    CustomCallout,
    ValidationProvider,
    ValidationObserver,
    CustomRadio,
    CustomTextArea,
    ActionButton,
  },
  mixins: [alertMixin],
  data() {
    return {
      verifyToggle: false,
      model: {
        discussionStatus: null,
        recommended: null,
        recomendationComment: null,
      },
      questions: [
        {
          id: 1,
          text: "¿Recomienda?",
          model: {},
          radioOptions: [
            {
              id: 1,
              name: "question1",
              label: "Sí",
              check: false,
              value: true,
            },
            {
              id: 2,
              name: "question2",
              label: "No",
              check: false,
              value: false,
            },
          ],
        },
      ],
      recommendedPanelShow: false,
      recommendedReasonSuccess: false,
    };
  },
  props: {
    itemsEval: {
      type: Object,
      default: () => ({
        disciplineTypeName: "",
        evaluationType: "",
        evaluationDate: null,
        statusName: "",
        status: "",
        reevaluationTime: "",
        reevaluationPeriod: "",
        reevaluationPurpose: "",
        discussionStatusId: null,
        discussionStatusDescription: "",
      }),
    },
    discussionStatuses: {
      type: Array,
      default: () => [],
    },
    isSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters.getIsMobileDensity;
    },
  },
  methods: {
    onChangeYesNo(answer) {
      this.recommendedPanelShow = true;
      this.recommendedReasonSuccess = true;
      this.model.recommended = answer.value;
      this.model.recomendationComment = null;
      this.questions = this.questions.map((q) => ({
        ...q,
        model: { radioAnswer: answer.id },
        radioOptions: q.radioOptions?.map((o) => ({
          ...o,
          check: o.id == answer.id,
        })),
      }));

      this.$emit("on-discussion-recommended-change", this.model.recommended);
    },
    handleCallout() {
      this.recommendedPanelShow = !this.recommendedPanelShow;
      this.verifyToggle = this.model.recommended != null;
    },
    handleCancel() {
      this.verifyToggle = false;
      this.recommendedPanelShow = false;
      this.recommendedReasonSuccess = false;
      this.model.recommended = null;
      this.questions = this.questions.map((q) => ({
        ...q,
        radioOptions: q.radioOptions?.map((o) => ({
          ...o,
          check: false,
        })),
      }));
      this.model.recomendationComment = null;
    },    
    async onChangeComment() {
      this.$emit(
        "change-recommendation-comment",
        this.model.recomendationComment
      );
    },
  },
  created() {
    if (this.itemsEval.discussionStatusId != null) {
      this.model.discussionStatus = {};
      this.model.discussionStatus.id = this.itemsEval.discussionStatusId;
    }

    if (this.itemsEval.recommended != null) {
      this.model.recommended = this.itemsEval.recommended;
      var itemIndex = this.questions[0].radioOptions.findIndex(
        (x) => x.value == this.itemsEval.recommended
      );

      var item = this.questions[0].radioOptions[itemIndex];
      item.check = true;
      this.questions[0].radioOptions[itemIndex] = item;
    }

    if (this.itemsEval.referralRequestReason != null) {
      this.model.recomendationComment = this.itemsEval.referralRequestReason;
      this.recommendedPanelShow = true;
    }
  },
};
</script>
<style>
div.v-select.custom-v-select.vs--single.vs--searchable div {
  max-height: 53px;
}
div.custom-radio-container .custom-radio-button {
  width: 60px !important;
}
</style>
<style scoped lang="scss">
@use "sass:map";
@import "@/assets/scss/variables/_colors.scss";
.dropdown-item {
  padding: 0.5rem 1.5rem;
}
.alt {
  background-color: #fafbfa;
}
.pointer {
  cursor: pointer;
}
.re-row {
  height: 80px;
}
.fs-13 {
  font-size: 13px;
}
.re-icon {
  font-size: 21px;
  font-weight: 900;
}
.re-icon.expanded {
  color: #2db782;
}
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #ffffff;
  font: 700 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: "";
  flex: 1;
  border-bottom: 1px solid #b5c3bc;
}
.dropdown-item.active,
.dropdown-item:active {
  background-color: transparent;
}
.label-centered {
  padding-left: 10px;
}
.border-bottom-2 {
  border-bottom: solid 1px #e2e2e2;
}
.bg-callout {
  background-color: #fafafa !important;
}

.custom-radio__extended ::v-deep {
  margin-left: 10px;
  padding-top: 10px;
  .custom-radio-button {
    background-color: #f2f2f2 !important;
  }
  .custom-radio-button.bg-green {
    background-color: #a3e5b3 !important;
  }
}
.divider-horizontal {
  border: 0.5px solid #e2e2e2 !important;
}

hr {
  border: 1px solid #e2e2e2 !important;
}
.recomendation-align {
  width: 300px;
  margin-left: -13px;
}
.vl {
  border-left: 1px solid #e5e5e5;
  height: 0px;
}
.evaluetions-card {
  background-color: #f7f7f7;
  padding-top: 10px;
  width: 100%;
  margin-left: -4px;
  height: 100%;
  min-height: 103px;
  border-radius: 8px;
  margin-bottom: 12px;
}
.pl-0 {
  position: relative;
  left: 10px;
}
.top-reductor {
  margin-top: -12px;
}

@media only screen and (min-width: 600px) {
  .top-reductor {
    margin-top: 0px;
  }
  .pl-0 {
    padding-left: 0px;
    position: relative;
    left: -65px;
  }

  .recomendation-align {
    width: 300px;
    margin-left: 43px;
  }
  .divider-horizontal {
    display: none;
  }
  .heigth-recomendation {
    height: 62px;
  }
  .vl {
    border-left: 1.5px solid #e5e5e5;
    height: 80px;
  }
  .label-centered {
    padding-left: 60px;
  }
  .evaluetions-card {
    background-color: white;
    padding-top: 10px;

    width: 100%;
    height: 93px;
    border-radius: 8px;
    margin-bottom: 12px;
  }
}

.btn-remove-evluation {
  position: absolute;
  right: 41px;
  top: 14px;
  width: 20px;
  height: 20px;
}
.btn-remove-evluation .btn {
  width: 20px;
  height: 20px;
}
</style>
